import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as keyCodes from "../../../constants/keyCodes";
import * as config from "../../../constants/config";
import * as settings from "../../../constants/settings";
import * as resources from "../../../constants/resources";
import * as validationHelper from "../../../helpers/validationHelper";
import * as conversionHelper from "../../../helpers/conversionHelper";
import * as modelHelper from "../../../helpers/modelHelper";
import * as colorHelper from "../../../helpers/colorHelper";

import imgDelete from "../../../resources/img/svgicons/delete.svg";
import imgPrint from "../../../resources/img/svgicons/print.svg";
import imgDispensing from "../../../resources/img/svgicons/dispensing2.svg";
import imgLoad from "../../../resources/img/svgicons/load-formula.svg";
import imgSettings from "../../../resources/img/svgicons/settings.svg";

import Modal from "../generic/Modal";
import Button from "../generic/Button";
import NumericKeyboardInput from "../../global/NumericKeyboardInput";
import ColorantBoxes from "./quickTint/ColorantBoxes";

export default class QuickTintModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedColorants: [],
            selectedUnit: this.props.unit,
            activeColorantRow: null
        };
    }

    setColorantValueState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.changeColorantValue(this.state.activeColorantRow, validationHelper.formatDecimal(value));
        }
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleSelectColorantClick = (event) => {
        let colorant = this.getColorantFromList(event.target.dataset.id);
        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            colorant.amountType = this.props.shotsName;
        }
        if (this.state.selectedUnit === settings.UNIT_G) {
            colorant.amountType = settings.UNIT_G;
        }
        if (colorant !== null) {
            this.setState({
                selectedColorants: [...this.state.selectedColorants, colorant]
            });
        }
    };

    handleRemoveColorantClick = (event) => {
        let colorant = this.getColorantFromSelectedList(event.target.dataset.id);

        if (colorant !== null) {
            this.setState({selectedColorants: this.getFilteredSelectedColorants(colorant)});
        }
    };

    handleColorantValueChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeColorantValue(event.target.dataset.id, validationHelper.formatDecimal(event.target.value));
        }
    };

    handleColorantValueFocus = (event) => {
        event.target.select();
        this.setState({
            activeColorantRow: event.target.dataset.id
        });
    };

    handleColorantValueBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeColorantValue(
                event.target.dataset.id,
                Number(validationHelper.formatDecimal(event.target.value))
            );
        }
        this.setState({
            activeColorantRow: null
        });
    };

    handleUnitChange = (event) => {
        let newColorants = [];
        let colorant;
        for (colorant of this.state.selectedColorants) {
            newColorants.push(
                colorant.updateAmountValues(
                    conversionHelper.convertAmountByColorant(
                        colorant,
                        this.state.selectedUnit,
                        event.target.value,
                        this.props.shotsCoef
                    ),
                    event.target.value === settings.UNIT_SHOT ? this.props.shotsName : event.target.value
                )
            );
        }

        this.setState({
            selectedColorants: newColorants,
            selectedUnit: event.target.value
        });
    };

    getFilteredSelectedColorants = (filteredColorant) => {
        return this.state.selectedColorants.filter(
            (colorant) => colorant.id + "-" + colorant.name !== filteredColorant.id + "-" + filteredColorant.name
        );
    };

    getFirstSelectedColorant = () => {
        if (this.state.selectedColorants.length > 0) {
            return this.state.selectedColorants[0];
        }
        return null;
    };

    getNextSelectedColorant = (colorantKey) => {
        let index;
        for (index = 0; index < this.state.selectedColorants.length; index++) {
            if (
                this.state.selectedColorants[index].id + "-" + this.state.selectedColorants[index].name ===
                colorantKey
            ) {
                if (index + 1 < this.state.selectedColorants.length) {
                    return this.state.selectedColorants[index + 1];
                }
                return null;
            }
        }
        return null;
    };

    changeColorantValue = (colorantKey, value) => {
        let changedColorant = this.getColorantFromSelectedList(colorantKey);

        if (changedColorant !== null) {
            this.setState({
                selectedColorants: this.state.selectedColorants.map((colorant) => {
                    if (colorant.id + "-" + colorant.name === colorantKey) {
                        return changedColorant.updateAmount(value);
                    }

                    return colorant;
                })
            });
        }
    };

    getColorantFromList = (colorantKey) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.colorant !== null && canister.colorant.id + "-" + canister.colorant.name === colorantKey) {
                return canister.colorant.clone();
            }
        }

        let colorant;
        for (colorant of this.props.colorantList) {
            if (colorant.id + "-" + colorant.name === colorantKey) {
                return colorant.clone();
            }
        }

        return null;
    };

    getColorantFromSelectedList = (colorantId) => {
        let selectedColorant;
        for (selectedColorant of this.state.selectedColorants) {
            if (selectedColorant.id + "-" + selectedColorant.name === colorantId) {
                return selectedColorant;
            }
        }

        return null;
    };

    maximumValueValidation = () => {
        let canister, colorant;
        for (colorant of this.state.selectedColorants) {
            for (canister of this.props.canisterList) {
                if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                    if (this.state.selectedUnit === settings.UNIT_ML) {
                        if (colorant.amount > canister.capacityMl || colorant.amount <= 0) {
                            return false;
                        }
                    }
                    if (this.state.selectedUnit === settings.UNIT_G) {
                        if (colorant.density === 0) {
                            return false;
                        }
                        if (
                            colorant.amount / colorant.density > canister.capacityMl ||
                            colorant.amount / colorant.density <= 0
                        ) {
                            return false;
                        }
                    }
                    if (this.state.selectedUnit === settings.UNIT_SHOT) {
                        if (
                            colorant.amount * this.props.shotsCoef > canister.capacityMl ||
                            colorant.amount * this.props.shotsCoef <= 0
                        ) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (
            this.state.selectedColorants.length > 0 &&
            prevState.selectedColorants.length !== this.state.selectedColorants.length
        ) {
            let lastIndex = this.state.selectedColorants.length;
            let lastColorant = this.state.selectedColorants[lastIndex - 1];

            // jQuery needs to have following special characters escaped by \\
            name = lastColorant.name.replaceAll(/[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, (match) => `\\${match}`);

            if (window.jQuery("#quick-tint-colorant-" + lastColorant.id + "-" + name).length) {
                window.jQuery("#quick-tint-colorant-" + lastColorant.id + "-" + name).focus();
            }
        }
    };

    handleSettingsButtonClick = () => {
        this.handleCloseModalClick();
        this.props.openSettings();
    };

    getSettingsButton = () => {
        if (this.props.redlikeSoftware && this.props.loggedUser.canNotEdit(resources.SUBMENU_QUINT_TINT)) {
            return "";
        }

        return <Button className="svg-only-btn" svgBefore={imgSettings} onClick={this.handleSettingsButtonClick} />;
    };

    getUnitsSelectBox = () => {
        let units = [];

        if (this.props.visibleUnits.ml || this.props.unit === settings.UNIT_ML) {
            units.push(
                <option key={settings.UNIT_ML} value={settings.UNIT_ML}>
                    {settings.UNIT_ML}
                </option>
            );
        }
        if (this.props.visibleUnits.g || this.props.unit === settings.UNIT_G) {
            units.push(
                <option key={settings.UNIT_G} value={settings.UNIT_G}>
                    {settings.UNIT_G}
                </option>
            );
        }
        if (this.props.visibleUnits.shots || this.props.unit === settings.UNIT_SHOT) {
            units.push(
                <option key={settings.UNIT_SHOT} value={settings.UNIT_SHOT}>
                    {this.props.shotsName}
                </option>
            );
        }

        if (units.length > 1) {
            return (
                <select
                    className="min-width-150 color-black primary-select"
                    value={this.state.selectedUnit}
                    onChange={this.handleUnitChange}
                >
                    {units}
                </select>
            );
        }

        return "";
    };

    getActiveColorantAmount = (selectedColorant) => {
        if (selectedColorant.id + "-" + selectedColorant.name === this.state.activeColorantRow) {
            return String(selectedColorant.amount);
        }

        return selectedColorant.formatAmount();
    };

    getSelectedColorantRows = () => {
        let rows = [];

        let selectedColorant, canister, rgb;
        for (selectedColorant of this.state.selectedColorants) {
            canister = this.getCanisterByColorant(selectedColorant);
            rgb = this.getCanisterRgb(canister, selectedColorant);
            rows.push(
                <div
                    key={selectedColorant.id + "-" + selectedColorant.name}
                    className="width-100per flex font-size-1_75em std-border-bottom flex-align-center"
                >
                    <div className="col-6 color-primary font-size-1_25em flex flex-align-center-vertical padding-top-5 padding-bottom-5">
                        <div className="color-square" style={{backgroundColor: rgb, height: "25px", width: "25px"}} />
                        <div>{selectedColorant.displayName}</div>
                    </div>
                    <div className="col-5 flex flex-align-center-vertical flex-gap-10px">
                        <NumericKeyboardInput
                            id={"quick-tint-colorant-" + selectedColorant.id + "-" + selectedColorant.name}
                            type="text"
                            className="text-right flex-child "
                            value={this.getActiveColorantAmount(selectedColorant)}
                            data-id={selectedColorant.id + "-" + selectedColorant.name}
                            onFocus={this.handleColorantValueFocus}
                            onBlur={this.handleColorantValueBlur}
                            onChange={this.handleColorantValueChange}
                            onKeyDown={this.handleColorantValueKeyDown}
                            extended={true}
                            setInputState={this.setColorantValueState}
                        />
                        {selectedColorant.amountType}
                    </div>
                    <div className="col-1 flex flex-end height-100per padding-top-5 padding-bottom-5">
                        <Button
                            className="svg-only-btn"
                            elementProps={{
                                "data-id": selectedColorant.id + "-" + selectedColorant.name
                            }}
                            svgBefore={imgDelete}
                            onClick={this.handleRemoveColorantClick}
                        />
                    </div>
                </div>
            );
        }

        return rows;
    };

    getCanisterByColorant = (colorant) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                return canister;
            }
        }

        return null;
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        if (colorant.rgb !== null) {
            return colorant.rgb;
        }

        return config.DEFAULT_RGB;
    };

    handlePrintKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            window.jQuery("#quick-tint-dispensing").focus();
        }
    };

    handleDispensingKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            let firstColorant = this.getFirstSelectedColorant();
            if (firstColorant !== null) {
                window.jQuery("#quick-tint-colorant-" + firstColorant.id + "-" + firstColorant.name).focus();
            } else {
                window.jQuery("#quick-tint-print").focus();
            }
        }
    };

    handleColorantValueKeyDown = (event) => {
        if (event.keyCode === keyCodes.TAB) {
            event.preventDefault();
            let nextColorant = this.getNextSelectedColorant(event.currentTarget.dataset.id);
            if (nextColorant === null) {
                window.jQuery("#quick-tint-print").focus();
            } else {
                window.jQuery("#quick-tint-colorant-" + nextColorant.id + "-" + nextColorant.name).focus();
            }
        }
    };

    getFormulaObject = () => {
        let formula = modelHelper.mapFormulaToObject(
            config.QUICK_TINT_ID,
            config.QUICK_TINT_ID,
            config.QUICK_TINT_NAME,
            translate("general.quickTint"),
            config.QUICK_TINT_NAME,
            this.props.generateColorPreview ? colorHelper.generateRgbByColorants(this.state.selectedColorants) : null
        );

        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            formula.colorantListShot = this.state.selectedColorants;
            return formula.updateColorantsMlByShots(this.props.shotsCoef);
        }

        if (this.state.selectedUnit === settings.UNIT_G) {
            formula.colorantListG = this.state.selectedColorants;
            return formula.updateColorantsMlByG(this.props.shotsCoef);
        }

        formula.colorantList = this.state.selectedColorants;

        return formula.updateColorantsByMl(this.props.shotsCoef);
    };

    handlePrintButtonClick = () => {
        this.props.quickPrint(
            validationHelper.getPrinter(this.props.printerList, this.props.selectedPrinter),
            validationHelper.getValidItem(this.props.templateList, this.props.templateName),
            this.getFormulaObject(),
            this.state.selectedUnit
        );
    };

    handleLoadFormulaClick = () => {
        this.props.loadQuickFormula(this.getFormulaObject());
    };

    handleDispensingClick = () => {
        this.props.startQuickDispense(this.getFormulaObject());
    };

    getDispensingBtnTooltipText = () => {
        if (this.props.dispensingInProgress) {
            return translate("quickTint.dispensingInProgress");
        }

        if (this.state.selectedColorants.length === 0) {
            return translate("quickTint.noColorantsSelected");
        }

        if (!this.props.connectedRcc) {
            return translate("general.rccIsNotConnected");
        }

        if (!this.props.machine.isConnected) {
            return translate("quickTint.machineNotConnected");
        }

        if (!this.maximumValueValidation()) {
            return translate("quickTint.overMaxCanisterSize");
        }

        return translate("quickTint.dispensingIsNotAvailable");
    };

    getPrintBtnTooltipText = () => {
        if (this.props.printerList.length === 0) {
            return translate("quickTint.noPrinterAvailable");
        }

        if (this.props.templateList.length === 0) {
            return translate("quickTint.noTemplateAvailable");
        }

        return translate("mainTab.printIsNotAvailable");
    };

    getPrintButton = () => {
        if (!this.props.printOnRequest || this.props.loggedUser.canNotRead(resources.FUNCTION_PRINT)) {
            return "";
        }

        if (
            this.state.selectedColorants.length === 0 ||
            this.props.dispensingFormula !== null ||
            this.props.dispensingInProgress ||
            !this.props.connectedRcc ||
            !this.props.machine.isConnected ||
            !this.maximumValueValidation() ||
            validationHelper.getValidItem(this.props.templateList, this.props.templateName) === null
        ) {
            return (
                <Button
                    id="quick-tint-print"
                    svgBefore={imgPrint}
                    tooltipText={this.getPrintBtnTooltipText()}
                    disabled={true}
                    label={<Translate value="general.print" />}
                />
            );
        }

        return (
            <Button
                id="quick-tint-print"
                svgBefore={imgPrint}
                elementProps={{
                    onKeyDown: this.handlePrintKeyDown
                }}
                onClick={this.handlePrintButtonClick}
                label={<Translate value="general.print" />}
            />
        );
    };

    getQuickTintButtons = () => {
        let buttons = [];

        if (
            this.state.selectedColorants.length > 0 &&
            this.props.dispensingFormula === null &&
            !this.props.dispensingInProgress &&
            this.props.connectedRcc &&
            this.props.machine.isConnected &&
            this.maximumValueValidation()
        ) {
            if (this.props.loggedUser.canEdit(resources.FUNCTION_DISPENSING)) {
                buttons.push(
                    <Button
                        id="quick-tint-dispensing"
                        key="dispensing-btn"
                        className="svg-ratio-2_1"
                        elementProps={{
                            onKeyDown: this.handleDispensingKeyDown
                        }}
                        onClick={this.handleDispensingClick}
                        label={<Translate value="general.dispense" />}
                        svgBefore={imgDispensing}
                    />
                );
            }

            if (this.props.redlikeSoftware) {
                buttons.push(
                    <Button
                        key="load-btn"
                        onClick={this.handleLoadFormulaClick}
                        label={<Translate value="general.loadFormula" />}
                        svgBefore={imgLoad}
                    />
                );
            }

            return buttons;
        }

        if (this.props.loggedUser.canEdit(resources.FUNCTION_DISPENSING)) {
            buttons.push(
                <Button
                    id="quick-tint-dispensing"
                    key="dispensing-btn"
                    className="svg-ratio-2_1"
                    elementProps={{
                        onKeyDown: this.handleDispensingKeyDown
                    }}
                    onClick={this.handleDispensingClick}
                    label={<Translate value="general.dispense" />}
                    svgBefore={imgDispensing}
                    tooltipText={this.getDispensingBtnTooltipText()}
                    disabled={true}
                />
            );
        }

        if (this.props.redlikeSoftware) {
            buttons.push(
                <Button
                    key="load-btn"
                    onClick={this.handleLoadFormulaClick}
                    label={<Translate value="general.loadFormula" />}
                    svgBefore={imgLoad}
                    tooltipText={this.getDispensingBtnTooltipText()}
                    disabled={true}
                />
            );
        }

        return buttons;
    };

    getContent = () => {
        if (!this.props.connectedRcc) {
            return modelHelper.buildModalSection(<Translate value="general.rccIsNotAvailable" />);
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="width-100per height-50per flex flex-column slim-scroll">
                    {this.getSelectedColorantRows()}
                </div>
                <ColorantBoxes
                    loggedUser={this.props.loggedUser}
                    activeDatabase={null}
                    selectedColorants={this.state.selectedColorants}
                    allowCanisterColorants={true}
                    canisterList={this.props.canisterList}
                    colorantList={this.props.colorantList}
                    databaseColorantList={null}
                    sorting={this.props.sorting}
                    spaceInPackage={null}
                    handleSelectColorantClick={this.handleSelectColorantClick}
                />
            </React.Fragment>,
            "flex flex-column height-100per"
        );
    };

    getFooter = () => {
        if (!this.props.connectedRcc) {
            return null;
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex margin-right-auto flex-gap-10px flex-align-center-vertical">
                    {this.getSettingsButton()}
                    <Translate className="color-primary" value="modal.changeColorantUnit" />
                    {this.getUnitsSelectBox()}
                </div>
                <div className="flex margin-left-auto flex-gap-10px flex-align-center-vertical">
                    {this.getQuickTintButtons()}
                    {this.getPrintButton()}
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.quickTint" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    width: "70%",
                    height: "80%"
                }}
            />
        );
    }
}
